<template>
  <Webcomponent
    v-model="comp"
    v-bind="$attrs"
    source="https://unpkg.com/@kvass/widgets@latest/dist/location-selector.js"
    tag="kvass-location-selector"
    :mapbox-api-token="access_token"
    :theme="style"
    class="field-location-selector"
  />
</template>

<script>
import Webcomponent from './Webcomponent.vue'
import { ValueComp } from '../utils'

export default {
  props: ['value'],
  data() {
    return {
      access_token: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
      style: process.env.VUE_APP_MAPBOX_STYLE,
    }
  },
  computed: {
    comp: ValueComp(),
  },

  components: {
    Webcomponent,
  },
}
</script>

<style lang="scss">
.field-location-selector {
  --kvass-location-selector-label-font-weight: 700;
  --kvass-location-selector-width: 100%;
  --kvass-location-selector-background: transparent;
}
</style>
